import { createFileRoute, Navigate, useRouterState } from '@tanstack/react-router';

import {
  crmCourseProfileCertificationStateSchema,
  crmCourseProfilePeopleViewSchema,
  crmCourseProfileSortSchema,
  crmCourseProfileTabSchema,
  customerLearningReturnToFromLegacyCourseLocation,
} from '@features/crm-course-profile';

export const Route = createFileRoute(
  '/$locale/_authenticated/crm/user-profiles/$userProfileId/learning/courses/$courseId'
)({
  component: LegacyCustomerCourseProfileRedirect,
});

function LegacyCustomerCourseProfileRedirect() {
  const { courseId, locale } = Route.useParams();
  const search = useRouterState({
    select: (state) =>
      state.location.search as {
        courseProfileCertificationState?: string;
        courseProfileCursor?: string;
        courseProfileCursorHistory?: string[];
        courseProfilePage?: number;
        courseProfilePeopleView?: string;
        courseProfileQ?: string;
        courseProfileSort?: string;
        courseProfileTab?: string;
      },
  });
  const currentLocation = useRouterState({ select: (state) => state.location.href });
  const hash = useRouterState({ select: (state) => state.location.hash });
  const returnTo = customerLearningReturnToFromLegacyCourseLocation(currentLocation);
  // The old match can remain mounted while its replace-navigation is committing.
  // Do not issue a second redirect using the destination's search state.
  if (returnTo === undefined) return null;
  const forwardedSearch = {
    courseProfileCertificationState: crmCourseProfileCertificationStateSchema.safeParse(
      search.courseProfileCertificationState
    ).data,
    courseProfileCursor: search.courseProfileCursor,
    courseProfileCursorHistory: search.courseProfileCursorHistory,
    courseProfilePage: search.courseProfilePage,
    courseProfilePeopleView: crmCourseProfilePeopleViewSchema.safeParse(
      search.courseProfilePeopleView
    ).data,
    courseProfileQ: search.courseProfileQ,
    courseProfileSort: crmCourseProfileSortSchema.safeParse(search.courseProfileSort).data,
    courseProfileTab: crmCourseProfileTabSchema.safeParse(search.courseProfileTab).data,
  };
  return (
    <Navigate
      to="/$locale/crm/courses/$courseId"
      params={{ courseId, locale }}
      search={{
        ...forwardedSearch,
        returnTo,
      }}
      hash={hash}
      replace
      resetScroll={false}
    />
  );
}
